import React from "react";
import AddressForm from "./AddressForm/AddressForm";

export default function Address(props) {
  const { formik, id, editingMode } = props;
  return <AddressForm formik={formik} id={id} editingMode={editingMode} />;
}
